import React, { useState } from 'react';
import './room3.css';

const GUESTS = [
  { id: 1, name: 'A. HARTWELL',  room: '3',  checkedOut: true  },
  { id: 2, name: 'B. CRANE',     room: '5',  checkedOut: true  },
  { id: 3, name: 'C. MORROW',    room: '2',  checkedOut: true  },
  { id: 4, name: 'D. FINCH',     room: '9',  checkedOut: true  },
  { id: 5, name: 'E. VOSS',      room: '7',  checkedOut: false },
  { id: 6, name: 'F. ALDGATE',   room: '11', checkedOut: true  },
];

const GuestPuzzle = ({ onClose, onSolve }) => {
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(false);
  const [phase, setPhase] = useState('registry'); // registry | portraits

  const handleSelect = (guest) => {
    setSelected(guest.id);
    setError(false);
  };

  const handleSubmit = () => {
    const pick = GUESTS.find(g => g.id === selected);
    if (pick && !pick.checkedOut) {
      onSolve();
    } else {
      setError(true);
      setTimeout(() => setError(false), 900);
    }
  };

  return (
    <div className="puzzleoverlay" onClick={onClose}>
      <div className={`puzzlemodal ${error ? 'puzzleshake' : ''}`} onClick={e => e.stopPropagation()}>
        <button className="puzzleclose" onClick={onClose}>✕</button>

        <h2 className="puzzletitle">THE GUEST REGISTRY</h2>
        <p className="puzzlesubtitle">
          One guest never checked out. Find them.
        </p>

        <div className="guestregistry">
          <div className="guestrow guestheader">
            <span>NAME</span>
            <span>ROOM</span>
            <span>STATUS</span>
          </div>
          {GUESTS.map(g => (
            <div
              key={g.id}
              className={`guestrow ${selected === g.id ? 'guestselected' : ''}`}
              onClick={() => handleSelect(g)}
            >
              <span>{g.name}</span>
              <span>Room {g.room}</span>
              <span className={g.checkedOut ? 'guestout' : 'guestmissing'}>
                {g.checkedOut ? 'Checked Out' : '——————'}
              </span>
            </div>
          ))}
        </div>

        {error && <p className="puzzleerror">That guest checked out. Look again.</p>}

        <button
          className="puzzlesubmit"
          onClick={handleSubmit}
          disabled={!selected}
        >
          IDENTIFY GUEST
        </button>
      </div>
    </div>
  );
};

export default GuestPuzzle;
